var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCardBlank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152 352H72C67.582 352 64 355.582 64 360S67.582 368 72 368H152C156.418 368 160 364.418 160 360S156.418 352 152 352ZM512 32H64C28.656 32 0 60.654 0 96V416C0 451.346 28.656 480 64 480H512C547.344 480 576 451.346 576 416V96C576 60.654 547.344 32 512 32ZM560 416C560 442.467 538.469 464 512 464H64C37.531 464 16 442.467 16 416V96C16 69.533 37.531 48 64 48H512C538.469 48 560 69.533 560 96V416ZM344 352H200C195.582 352 192 355.582 192 360S195.582 368 200 368H344C348.418 368 352 364.418 352 360S348.418 352 344 352Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardBlank);
export default __webpack_public_path__ + "static/media/credit-card-blank.120b76e4227ae793b432b8ce671021e0.svg";
export { ForwardRef as ReactComponent };